module.exports = __webpack_public_path__ + "static/media/eye.c1d10df6.svg";